import { Alert, Button, Spinner } from "react-bootstrap";
import { PAGE_SIZE } from "../../../../../services/QueryParamService";
import { ParamUrlsView } from "./QueryParamFinderSlice";
import { copyToClipboard } from "./copyToClipboard";

export type ParamUrlsPanelProps = {
  readonly view: ParamUrlsView | undefined;
  readonly onPage: (offset: number) => void;
};

type LoadedProps = { readonly view: ParamUrlsView; readonly onPage: (offset: number) => void };

const UrlLinks = ({ view, onPage }: LoadedProps) => (
  <>
    <div className="d-flex justify-content-between align-items-center mb-2">
      <span>{view.urls.length.toLocaleString("en-US")} URLs on this page</span>
      <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(view.urls.join("\n"))}>
        Copy URLs
      </Button>
    </div>
    <ul className="list-unstyled mb-2">
      {view.urls.map((url) => (
        <li key={url} className="text-break">
          <a href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </a>
        </li>
      ))}
    </ul>
    <div className="d-flex align-items-center gap-2">
      <Button size="sm" variant="outline-secondary" aria-label="Previous page" disabled={view.offset === 0} onClick={() => onPage(view.offset - PAGE_SIZE)}>
        Prev
      </Button>
      <span>Page {view.offset / PAGE_SIZE + 1}</span>
      <Button size="sm" variant="outline-secondary" aria-label="Next page" disabled={!view.hasMore} onClick={() => onPage(view.offset + PAGE_SIZE)}>
        Next
      </Button>
    </div>
  </>
);

const ParamUrlsPanel = ({ view, onPage }: ParamUrlsPanelProps) => {
  if (view?.error) return <Alert variant="danger" className="mb-0">{view.error}</Alert>;
  if (!view || view.loading) return <Spinner animation="border" size="sm" role="status" aria-label="Loading URLs" />;
  return <UrlLinks view={view} onPage={onPage} />;
};

export default ParamUrlsPanel;
